// main root endpoint
export const API_ROOT = process.env.REACT_APP_BACKEND_URI;
export const API_ROOT_LOCATION = process.env.REACT_APP_BACKEND_URI;
export const ROOT = process.env.REACT_APP_VERSION;
// all api end points
export const API_END_POINTS = {
  login: `${ROOT}/admin/auth/login`,
  superAdminSendOTP: `${ROOT}/admin/auth/super-admin/send-otp`,
  superAdminVerifyOTP: `${ROOT}/admin/auth/super-admin/verify-otp`,
  authCheck: `${ROOT}/admin/auth/check`,
  authRefreshCaptcha: `${ROOT}/admin/auth/refresh-captcha`,
  authCheckCaptcha: `${ROOT}/admin/auth/check-captcha`,
  changePassword: `${ROOT}/admin/auth/change-password`,
  getLoginHistoryList: `${ROOT}/admin/auth/login-history/list`,
  getProfile: `${ROOT}/admin/auth/view-profile`,
  updateProfile: `${ROOT}/admin/auth/update-profile`,
  verifyEmail: `${ROOT}/admin/auth/verify-email`,
  resendVerifyEmail: `${ROOT}/admin/auth/send-link-email-verify-email`,
  resetPassword: `${ROOT}/admin/auth/set-password`,
  getSoftwareList: `${ROOT}/admin/game-upload/game-list`,
  UpdateSoftware: `${ROOT}/admin/kiosk-routes/add`,
  UpdateApplicationVersion: `${ROOT}/admin/auth/update-mobile-game-app-version`,
  getApplicationVersionList: `${ROOT}/admin/auth/version`,
  downloadKioskSoftware: `${ROOT}/admin/game-upload/download`,
  resendEmailSetPassword: `${ROOT}/admin/auth/resend-email-set-password`,
  getOperators: `${ROOT}/admin/operator/list`,
  updateOperatorStatus: `${ROOT}/admin/operator/status`,
  createOperator: `${ROOT}/admin/operator/register`,
  updateOperator: `${ROOT}/admin/operator/update-profile`,
  getUsers: `${ROOT}/admin/user/user-list`,
  getUser: `${ROOT}/admin/user/view-user`,
  updateUserStatus: `${ROOT}/admin/user/change-status`,
  createUser: `${ROOT}/admin/user/create-user`,
  updateUser: `${ROOT}/admin/user/update-profile`,
  getUserRole: `${ROOT}/admin/user/list-role`,
  assignUserRole: `${ROOT}/admin/user/assign-role`,
  getTransactions: `${ROOT}/admin/transaction/transaction-list`,
  getIapDetail: `${ROOT}/admin/transaction/iap-detail`,
  getAdvertises: `${ROOT}/admin/advertisement/advertisement-list`,
  createAdvertise: `${ROOT}/admin/advertisement/create-advertisement`,
  getAdvertise: `${ROOT}/admin/advertisement/view-advertisement`,
  updateAdvertiseStatus: `${ROOT}/admin/kiosk-routes/change-status`,
  updateAdvertise: `${ROOT}/admin/kiosk-routes/update-advertisement`,
  deleteAdvertise: `${ROOT}/admin/advertisement/delete-advertisement`,
  getSingleOperator: `${ROOT}/admin/operator/single-operator`,
  getCustomers: `${ROOT}/admin/customer/customer-list`,
  getCustomersBalance: `${ROOT}/admin/transaction/customer-balance`,
  updateCustomerStatus: `${ROOT}/admin/customer/change-status`,
  customerDropdown: `${ROOT}/admin/customer/dropdown`,
  adminGetLocations: `${ROOT}/admin/location/list`,
  adminUpdateLocationStatus: `${ROOT}/admin/location/status`,
  adminGetSingleLocation: `${ROOT}/admin/location/single-location`,
  adminLocationReferralFlyer: `${ROOT}/admin/location/referral-flyer`,
  adminUpdateLocationReferral: `${ROOT}/admin/location/update-referral`,
  operatorDropdown: `${ROOT}/admin/operator/dropdown`,
  locationDropdown: `${ROOT}/admin/location/dropdown`,
  getDistributors: `${ROOT}/admin/distributor/distributor-list`,
  updateDistributorStatus: `${ROOT}/admin/distributor/change-status`,
  distributorDropdown: `${ROOT}/admin/distributor/dropdown`,
  createDistributor: `${ROOT}/admin/distributor/distributor-add`,
  getSingleDistributor: `${ROOT}/admin/distributor/view-distributor`,
  updateDistributor: `${ROOT}/admin/distributor/distributor-update`,
  getKiosk: `${ROOT}/admin/kiosk/get-kiosk`,
  getKioskModalDropdown: `${ROOT}/admin/kiosk/dropdown-kiosk`,
  createKiosModal: `${ROOT}/admin/kiosk/save-update-kiosk`,
  deleteKiosModal: `${ROOT}/admin/kiosk/kiosk-model-delete`,
  updateKioskByDestributor: `${ROOT}/admin/kiosk/update-distributor-model`,
  getTax: `https://www.promitool.com/tax-zip/api/v1`,
  getInvoices: `${ROOT}/admin/super-admin-invoice/list`,
  getInvoice: `${ROOT}/admin/super-admin-invoice/get`,
  addInvoice: `${ROOT}/admin/super-admin-invoice/create`,
  updateInvoiceStatus: `${ROOT}/admin/super-admin-invoice/update-status`,
  invoiceEditItem: `${ROOT}/admin/super-admin-invoice/update-item`,
  invoiceDeleteItem: `${ROOT}/admin/super-admin-invoice/remove-item`,
  createReceipt: `${ROOT}/admin/super-admin-invoice/add-receipt`,
  confirmReceipt: `${ROOT}/admin/super-admin-invoice/clear-payment`,
  completeInvoice: `${ROOT}/admin/super-admin-invoice/set-invoice-done`,
  SendMail: `${ROOT}/admin/super-admin-invoice/send-mail`,
  ViewPDFData: `${ROOT}/admin/super-admin-invoice/get-pdf`,
  getDeleteDoc: `${ROOT}/admin/auth/delete-image`,
  generateKiosk: `${ROOT}/admin/kiosk/generate-kioskId`,
  getKiosks: `${ROOT}/admin/kiosk/list-kioskId`,
  addKiosk: `${ROOT}/admin/super-admin-invoice/add-terminal`,
  removeKiosk: `${ROOT}/admin/super-admin-invoice/remove-terminal`,
  kioskDropdown: `${ROOT}/admin/kiosk/dropdown-kioskId`,
  getAdminStatement: `${ROOT}/admin/statement/admin-list`,
  getSelfAdminStatement: `${ROOT}/admin/statement/admin-self-list`,
  getSelfOperatorStatement: `${ROOT}/admin/statement/operator-self-list`,
  getSuperAdminStatement: `${ROOT}/admin/statement/super-admin-list`,
  getOperatorStatement: `${ROOT}/admin/statement/operator-list`,
  generateStatement: `${ROOT}/admin/statement/super-admin-add`,
  generateDistributorStatment: `${ROOT}/admin/statement/admin-add`,
  getLocationStatement: `${ROOT}/admin/statement/location-list`,
  updateStatmentStatus: `${ROOT}/admin/statement/update-status`,
  UpdateKioskKeys: `${ROOT}/admin/kiosk-routes/update-kiosk-admin-user-key`,
  changeKioskStatus: `${ROOT}/admin/kiosk-routes/location-outOfService`,
  changeUserStatus: `${ROOT}/admin/customer/user-outOfService`,
  serverMaintenance: `${ROOT}/admin/kiosk-routes/set-and-cancel-server-under-maintenance`,
  getServerMaintenance: `${ROOT}/admin/auth/get-server-under-maintenance`,
  restartKioskInSecond: `${ROOT}/admin/setting/update`,
  deleteInvoice: `${ROOT}/admin/super-admin-invoice/delete`,
  createReturnInvoice: `${ROOT}/admin/super-admin-invoice/create-return`,
  kioskStatusCount: `${ROOT}/admin/dashboard/kiosk-count`,
  invoiceCount: `${ROOT}/admin/dashboard/invoice-collection`,
  billCount: `${ROOT}/admin/dashboard/invoice-payment`,
  userCount: `${ROOT}/admin/dashboard/user-count`,
  ratioCount: `${ROOT}/admin/dashboard/get-calculation`,
  moneyInOut: `${ROOT}/admin/dashboard/money-count`,
  customerCount: `${ROOT}/admin/dashboard/customer-count`,
  commisionCount: `${ROOT}/admin/dashboard/commission`,
  paymentCount: `${ROOT}/admin/dashboard/payment`,
  dashboardChart: `${ROOT}/admin/dashboard/chart`,
  getLocationDashboard: `${ROOT}/admin/location/get-dashboard`,
  getProfitListDahboard: `${ROOT}/admin/dashboard/user-list`,
  UploadImage: `${ROOT}/upload-image`,
  changeWinningRatio: `${ROOT}/admin/auth/update-start-winning-ratio`,
  cashManagement: `${ROOT}/admin/kiosk-report/cash-management`,
  transactionrReport: `${ROOT}/admin/kiosk-report/transaction-report`,
  cycleItemReport: `${ROOT}/admin/kiosk-report/cycle-item-report`,
  cycleItemReportAll: `${ROOT}/admin/kiosk-report/cycle-report`,
  getDropdown: `${ROOT}/admin/kiosk-report/date-dropdown`,
  getCreditLimit: `${ROOT}/admin/dashboard/credit-list`,
  getBonusListApi: `${ROOT}/admin/customer/bonus-data`,
  mgmListApi: `${ROOT}/admin/mgm-data/list`,
  fishJackpotListApi: `${ROOT}/admin/fish-jackpot-data/list`,
  buyBonusListApi: `${ROOT}/admin/bonus-purchase/list`,
  getCustomerListBonusListApi: `${ROOT}/admin/customer/customer-list-bonus`,
  getSubscriptionListApi: `${ROOT}/admin/subscription/list`,
  createSubscriptionApi: `${ROOT}/admin/subscription`,
  getSingleSubscriptionApi: `${ROOT}/admin/subscription`,
  updateSubscriptionApi: `${ROOT}/admin/subscription`,
  deleteSubscriptionApi: `${ROOT}/admin/subscription`,
  getUserSubscriptionHistoryListApi: `${ROOT}/admin/user-subscription/list`,
  getSubscriptionDropdownApi: `${ROOT}/admin/subscription/dropdown`,
  getSubscriptionCountApi: `${ROOT}/admin/dashboard/subscription-count`,
  getScratchEventListApi: `${ROOT}/admin/scratch-events/list`,
  createScratchEventApi: `${ROOT}/admin/scratch-events/create`,
  getSingleScratchEventApi: `${ROOT}/admin/scratch-events`,
  getScratchEventDropdownApi: `${ROOT}/admin/scratch-events/dropdown`,
  updateScratchEventApi: `${ROOT}/admin/scratch-events/update`,
  deleteScratchEventApi: `${ROOT}/admin/scratch-events/delete`,
  getHistoryOfScratchEventApi: `${ROOT}/admin/scratch-events/user-scratch-list`,
  //Distributor Panal
  getInvoicesAdmin: `${ROOT}/admin/admin-invoice/list`,
  getInvoiceAdmin: `${ROOT}/admin/admin-invoice/get`,
  addInvoiceAdmin: `${ROOT}/admin/admin-invoice/create`,
  updateInvoiceStatusAdmin: `${ROOT}/admin/admin-invoice/update-status`,
  invoiceEditItemAdmin: `${ROOT}/admin/admin-invoice/update-item`,
  invoiceDeleteItemAdmin: `${ROOT}/admin/admin-invoice/remove-item`,
  createReceiptAdmin: `${ROOT}/admin/admin-invoice/add-receipt`,
  confirmReceiptAdmin: `${ROOT}/admin/admin-invoice/clear-payment`,
  completeInvoiceAdmin: `${ROOT}/admin/kiosk-routes/set-invoice-done`,
  SendMailAdmin: `${ROOT}/admin/admin-invoice/send-mail`,
  ViewPDFDataAdmin: `${ROOT}/admin/admin-invoice/get-pdf`,
  addKioskAdmin: `${ROOT}/admin/admin-invoice/add-terminal`,
  removeKioskAdmin: `${ROOT}/admin/admin-invoice/remove-terminal`,
  deleteInvoiceAdmin: `${ROOT}/admin/admin-invoice/delete`,
  createReturnInvoiceAdmin: `${ROOT}/admin/admin-invoice/create-return`,
  viewDistributorStatementPdf: `${ROOT}/admin/statement/distributor-pdf`,
  //Operator Panal
  operatorChangePassword: `${ROOT}/operator/customer/change-password`,
  operatorGetProfile: `${ROOT}/operator/customer/view-profile`,
  operatorUpdateProfile: `${ROOT}/operator/customer/update-profile`,
  operatorGetUsers: `${ROOT}/operator/user/user-list`,
  operatorGetUser: `${ROOT}/operator/user/view-user`,
  operatorUpdateUserStatus: `${ROOT}/operator/user/change-status`,
  operatorCreateUser: `${ROOT}/operator/user/create-user`,
  operatorUpdateUser: `${ROOT}/operator/user/update-profile`,
  operatorGetUserRole: `${ROOT}/operator/user/list-role`,
  operatorAssignUserRole: `${ROOT}/operator/user/assign-role`,
  createLocation: `${ROOT}/operator/location/register`,
  updateLocation: `${ROOT}/operator/location/update-profile`,
  logoutKioskLocation: `${ROOT}/admin/kiosk-routes/logout`,
  operatorGenerateLocationStatement: `${ROOT}/operator/location/location-statement-generate`,
  viewOperatorStatementPdf: `${ROOT}/admin/statement/operator-pdf`,

  // promoCode
  createPromoCode: `${ROOT}/admin/kiosk-routes/promo-offer/create`,
  getPromoCode: `${ROOT}/admin/promo-offer/list`,
  getSinglePromoCode: `${ROOT}/admin/promo-offer`,
  updatePromoCode: `${ROOT}/admin/kiosk-routes/promo-offer/update`,
  updatePromoCodeStatus: `${ROOT}/admin/kiosk-routes/promo-offer/update`,
  deletePromoCode: `${ROOT}/admin/kiosk-routes/promo-offer/delete`,
  promoOfferDropdown: `${ROOT}/admin/promo-offer/dropdown`,
  operatorPromoOfferDropdown: `${ROOT}/operator/location/promo-offer-dropdown`,

  // collection invoice
  collectionInvoiceList: `${ROOT}/admin/collection-invoice/list`,
  getCollectionInvoice: `${ROOT}/admin/collection-invoice`,
  collectionInvoicePDF: `${ROOT}/admin/collection-invoice/pdf`,

  // coupon code
  couponCodePlayersPreviewApi: `${ROOT}/admin/coupon/players-preview`,
  createCouponCodeApi: `${ROOT}/admin/coupon/create`,
  getCouponCodeListApi: `${ROOT}/admin/coupon/list`,
  getCouponByNameApi: `${ROOT}/admin/coupon/get-by-name`
};
